import { render, staticRenderFns } from "./BottomSectionSettings.vue?vue&type=template&id=61fa0282&"
import script from "./BottomSectionSettings.vue?vue&type=script&lang=js&"
export * from "./BottomSectionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports